import { makePostRequest } from "../helpers"

export const activatePatient = async (patientId: string) => {
    return await makePostRequest(`/api/patients/${patientId}/activate`, {});
}

export const deactivatePatient = async (patientId: string) => {
    return await makePostRequest(`/api/patients/${patientId}/deactivate`, {});
}
